import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Form, Field } from "react-final-form";
import { useParams } from "react-router";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import HeaderBox from "../../reuseableComponents/headerBox";
import RoutineBacteriologicalSamplingRequirementTable from "./RoutineBacteriologicalSamplingRequirementTable";
import TotalColiformSampleTable from "./TotalColiformSampleTable";
import SourcesTablePublic from "./SourceTablePublic";

const BacterialSummaryReport = () => {
  let { systemId } = useParams();

  let today = new Date();
  let defaultFromDate = new Date(today.getFullYear() - 1, today.getMonth() - 1, 1);
  let lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
  let defaultToDate = new Date(today.getFullYear(), today.getMonth(), lastDayOfMonth);
  let defaultFromString = defaultFromDate.toJSON().split("T")[0];
  let defaultToString = defaultToDate.toJSON().split("T")[0];

  const [fromDate, setFromDate] = useState(defaultFromString);
  const [toDate, setToDate] = useState(defaultToString);

  const onSubmit = (values) => {
    setFromDate(values.fromDate);
    setToDate(values.toDate);
  };

  return (
    <>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='bacterialSummaryReport'>
            <h3 style={{ color: "#fff" }}>Bacterial Summary Report</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Routine Bacteriological Sampling Requirements</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <RoutineBacteriologicalSamplingRequirementTable systemId={parseInt(systemId)} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Total Coliform Distribution Sampling</h3>
        </Col>
        <Col>
          <h3 className='float-end'>Groundwater Rule Source Sampling</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, form, submitting, values }) => (
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col>
                    <Field
                      name='fromDate'
                      component='input'
                      type='date'
                      className='form-control m-2'
                      initialValue={fromDate}
                      cypressid='fromDate'
                    />
                  </Col>
                  <Col>
                    <Field
                      name='toDate'
                      component='input'
                      type='date'
                      className='form-control m-2'
                      initialValue={toDate}
                      cypressid='toDate'
                    />
                  </Col>
                  <Col>
                    <ButtonSubmit
                      id='ddw-primary'
                      onClick={() => onSubmit(values)}
                      cypressid='totalColiformSearchSubmit'
                    />
                  </Col>
                </Row>
              </form>
            )}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <TotalColiformSampleTable systemId={parseInt(systemId)} fromDate={fromDate} toDate={toDate} />
        </Col>
      </Row>
      <Row>
        <Col>
          <h3>Sources</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <SourcesTablePublic systemId={parseInt(systemId)} />
        </Col>
      </Row>
    </>
  );
};

export default BacterialSummaryReport;
